import { PageHeader } from "@ant-design/pro-components";
import {
  Alert,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Modal,
  Select,
  Space,
  message,
} from "antd";
import { DollarOutlined, PlusOutlined } from "@ant-design/icons";
import styles from "./PaymentSkip.module.css";
import * as actions from "../../../store/actions/action";
import { connect } from "react-redux";
import api from "../../../api/api";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian_fa from "react-date-object/locales/persian_fa";
import jalali from "react-date-object/calendars/jalali";

const PRODUCT_TO_EPOLL_FORM_ID = {
  "roadmap-psychology": "61966",
  "roadmap-1": "41744",
  "roadmap-2": "57755",
  "roadmap-3": "67506",
};

const PaymentSkip = ({ userData, onLogout }) => {
  const [form] = Form.useForm();

  const [items, setItems] = useState(["بلاگر", "پلنیوم"]);
  const [name, setName] = useState("");
  const [formList, setFormList] = useState([]);
  const PLANIUM_FORM_PRODUCTS = ["roadmap-3", "roadmap-civil"];
  const selectedProduct = Form.useWatch("product", form);
  const isPlaniumFormProduct = PLANIUM_FORM_PRODUCTS.includes(selectedProduct);
  const epollFormIdForProduct = PRODUCT_TO_EPOLL_FORM_ID[selectedProduct];
  const planiumFormRequired =
    !!selectedProduct && !epollFormIdForProduct;
  const inputRef = useRef(null);
  const onNameChange = (event) => {
    setName(event.target.value);
  };
  const addItem = (e) => {
    e.preventDefault();
    setItems([...items, name || `تگ جدید`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const loadTags = () => {
    api
      .get("/order/skip-payment-tags")
      .then((res) => {
        setItems(res.data);
      })
      .catch((e) => {
        message.error("خطا در دریافت لیست تگ ها");
      });
  };

  useEffect(() => {
    loadTags();

    api
      .get("/forms/list")
      .then((res) => setFormList(res.data))
      .catch(() => message.error("خطا در دریافت لیست پرسشنامه ها"));
  }, []);

  const [result, setResult] = useState({
    message: "",
    type: "",
  });
  const [paymentDate, setPaymentDate] = useState(new Date());

  const submitSkipPayment = () => {
    const { payAmount, paymentData, tag, planiumForm, ...other } =
      form.getFieldValue();

    const bodyData = {
      ...other,
      paymentDate,
      payAmount: parseInt(payAmount.replaceAll(",", "")),
    };

    if (tag && tag !== "") bodyData.tag = tag;
    if (planiumForm !== undefined) bodyData.planiumForm = planiumForm;

    setResult({
      message: "در حال ارسال درخواست...",
      type: "info",
    });
    api
      .post("/order/skippayment", bodyData)
      .then((res) => {
        message.success("رد شدن از پرداخت با موفقیت اعمال شد");
        setResult({
          message: "رد شدن از پرداخت با موفقیت اعمال شد",
          type: "success",
        });
      })
      .catch((error) => {
        message.error(error.response?.data?.error?.message || "خطا در ثبت");
        setResult({
          message: error.response?.data?.error?.message || "خطا در ثبت",
          type: "error",
        });
      });
  };

  const sendRequest = () => {
    const mobile = form.getFieldValue("mobile");
    const product = form.getFieldValue("product");
    const planiumForm = form.getFieldValue("planiumForm");

    if (!mobile || !product) {
      message.warning("لطفا موبایل و محصول را وارد کنید");
      return;
    }

    if (planiumFormRequired && !planiumForm) {
      message.warning(
        "این محصول پرسشنامه ایپل ندارد. لطفا پرسشنامه پلنیوم را انتخاب کنید."
      );
      return;
    }

    api
      .get(`/order/skip-payment-check/${mobile}/${product}`)
      .then((res) => {
        const { roadmapStatus } = res.data;

        if (roadmapStatus === "PENDING") {
          // User already has an unpublished roadmap for this product → block.
          const msg =
            "این کاربر هم اکنون نقشه راه فعالی برای این محصول دارد که هنوز نهایی نشده است.";
          setResult({ message: msg, type: "error" });
          message.error(msg);
          return;
        }

        if (roadmapStatus === "PUBLISHED") {
          // User already has a published roadmap for this product → confirm popup.
          Modal.confirm({
            title: "نقشه راه دوم",
            content:
              "این کاربر قبلا یک نقشه راه منتشر شده برای این محصول دارد. آیا می‌خواهید برای نقشه راه دوم از پرداخت رد شود؟",
            okText: "بله، رد از پرداخت",
            cancelText: "انصراف",
            onOk: submitSkipPayment,
          });
          return;
        }

        // roadmapStatus === "NONE" → new user, submit directly.
        submitSkipPayment();
      })
      .catch(() => {
        message.error("خطا در بررسی وضعیت کاربر");
      });
  };

  const changePayAmountHandler = (e) => {
    let payAmount = parseInt(e.target.value.replaceAll(",", ""));
    if (isNaN(payAmount)) payAmount = 0;

    payAmount = payAmount.toLocaleString();

    form.setFieldValue("payAmount", payAmount);
  };

  useEffect(() => {
    try {
      form.setFieldValue(
        "paymentDate",
        new Date(paymentDate.toUTC()).toISOString()
      );
    } catch (error) {}
  }, [paymentDate, form]);

  useEffect(() => {
    if (!isPlaniumFormProduct) {
      form.setFieldValue("planiumForm", undefined);
    }
  }, [isPlaniumFormProduct, form]);

  return (
    <div className={styles.PaymentSkip}>
      <PageHeader
        title="رد کردن از پرداخت"
        avatar={{ icon: <DollarOutlined />, size: "large" }}
      />

      <Card className={styles.Form} loading={userData ? false : true}>
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          initialValues={{
            group: "PLANIUM",
            gateway: "PAY_PING",
            product: "roadmap-3",
            planiumForm: false,
          }}
        >
          {/* phone */}
          <Form.Item
            name="mobile"
            label="موبایل"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          {/* firstname */}
          <Form.Item name="firstname" label="نام">
            <Input />
          </Form.Item>

          {/* lastname */}
          <Form.Item name="lastname" label="نام خانوادگی">
            <Input />
          </Form.Item>

          {/* product */}
          <Form.Item
            name="product"
            label="محصول"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              style={{
                width: "100%",
              }}
              placeholder="انتخاب کنید"
              options={[
                { label: "نقشه راه اتوماتیک", value: "roadmap-3" },
                // { label: "نقشه راه بوکمارکی", value: "roadmap-2" },
                { label: "نقشه راه روان شناسی", value: "roadmap-psychology" },
                { label: "نقشه راه عمران", value: "roadmap-civil" },
                // { label: "نقشه راه قدیم", value: "roadmap-1" },
              ]}
            />
          </Form.Item>

          {/* Date picker */}
          <Form.Item
            name="paymentData"
            label="تاریخ پرداخت"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <DatePicker
              format="HH:mm - YYYY/MM/DD"
              onChange={(d) => setPaymentDate(new Date(d.toDate()))}
              calendar={jalali}
              locale={persian_fa}
              plugins={[<TimePicker position="left" />]}
              render={(value, openCalendar) => {
                return (
                  <Input
                    value={value}
                    onClick={openCalendar}
                    style={{ width: "22rem" }}
                  />
                );
              }}
            />
          </Form.Item>

          {/* payAmount */}
          <Form.Item
            name="payAmount"
            label="مبلغ پرداختی"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input suffix="تومان" onChange={changePayAmountHandler} />
          </Form.Item>

          {/* skip payment group */}
          <Form.Item
            name="group"
            label="گروه"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              defaultValue={"PLANIUM"}
              options={[
                { value: "RABIN", label: <span>رابین</span> },
                { value: "PLANIUM", label: <span>پلنیوم</span> },
              ]}
            />
          </Form.Item>

          {/* gateway */}
          <Form.Item
            name="gateway"
            label="درگاه"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              defaultValue={"PAY_PING"}
              options={[
                { value: "PAY_PING", label: <span>پی پینگ</span> },
                { value: "SNAPP_PAY", label: <span>اسنپ پی</span> },
                { value: "zibal", label: <span>زیبال</span> },
                { value: "card-to-card", label: <span>کارت به کارت</span> },
              ]}
            />
          </Form.Item>

          {/* utm_campaign */}
          <Form.Item name="utm_campaign" label="utm_campaign">
            <Input />
          </Form.Item>

          {/* utm_source */}
          <Form.Item name="utm_source" label="utm_source">
            <Input />
          </Form.Item>

          {/* utm_medium */}
          <Form.Item name="utm_medium" label="utm_medium">
            <Input />
          </Form.Item>

          {/* tag */}
          <Form.Item name="tag" label="تگ">
            <Select
              style={{ width: "100%" }}
              placeholder="تگ"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Input
                      placeholder="افزودن تگ جدید"
                      ref={inputRef}
                      value={name}
                      onChange={onNameChange}
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                    >
                      افزودن
                    </Button>
                  </Space>
                </>
              )}
              options={items.map((item) => ({
                label: item,
                value: item,
              }))}
            />
          </Form.Item>

          {/* description */}
          <Form.Item name="description" label="توضیحات">
            <Input />
          </Form.Item>

          {/* planiumForm — for planium-form products or any product w/o epoll */}
          {(isPlaniumFormProduct || planiumFormRequired) && (
            <Form.Item
              name="planiumForm"
              label="پرسشنامه پلنیوم"
              rules={[
                {
                  required: planiumFormRequired,
                  message:
                    "این محصول پرسشنامه ایپل ندارد. باید پرسشنامه پلنیوم انتخاب شود.",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                placeholder="انتخاب کنید"
                allowClear
                options={formList.map((el) => ({
                  label: el.title,
                  value: el.id,
                }))}
              />
            </Form.Item>
          )}

          {/* epoll form info for epoll-form products */}
          {!isPlaniumFormProduct && epollFormIdForProduct && (
            <Form.Item label="پرسشنامه ایپل">
              <Alert
                type="info"
                showIcon
                message={`این محصول از پرسشنامه ایپل (شناسه ${epollFormIdForProduct}) استفاده می‌کند و نیازی به انتخاب دستی نیست.`}
              />
            </Form.Item>
          )}

          {/* submit */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                sendRequest();
              }}
            >
              رد کردن از پرداخت
            </Button>
          </Form.Item>

          {result.message && (
            <Alert message={result.message} type={result.type} />
          )}
        </Form>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(actions.Logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSkip);
